export default function getEntity(keyEntities, key) {
  return keyEntities[key];
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/rc-tree/es/utils/keyUtil.js
// module id = 339
// module chunks = 0